import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_PewFy4aQqF51: {
	id: 'prd_PewFy2DEV24aQqF51'
	ident: 'prd_PewFy4aQqF51'
	sku: 'simple_premium_12w_19_19_12w_99_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 12
			iteration_count: 1
			price_id: 'prc_sTNzL2DEV2ANlP7p3'
			amount: 99
			amount_usd: 19.19
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 19.19
			discount: 79.81
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 12
			iteration_count: null
			price_id: 'prc_kpWCM2DEV2IZAyvid'
			amount: 99
			amount_usd: 99
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_PewFy4aQqF51, SubscriptionProduct>
const prd_PewFy4aQqF51 = { ident: 'prd_PewFy4aQqF51' } as typeof _prd_PewFy4aQqF51

export default prd_PewFy4aQqF51
